import { c as _c } from "react/compiler-runtime";
import { Box } from "@mui-wrapper";
import { Skeleton } from "@flat-ui";

/** Number of rows to show in sidebar */
const NUMBER_OF_ROWS = 4;

/**
 * Renders a skeleton loading component for the sidebar.
 *
 * @returns {JSX.Element} The SidebarSkeleton component.
 */
export function SidebarSkeleton() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Box sx={{
      mt: "10px"
    }}>{[...Array(NUMBER_OF_ROWS)].map(_temp)}</Box>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
function _temp(_, index) {
  return <Skeleton key={index} variant="rectangular" sx={{
    width: "100%",
    height: "48px",
    mb: "10px"
  }} />;
}